//@ts-nocheck
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import T from 'prop-types'
import compose from 'utils/compose'
import { withManager } from '@wework/react-floormap'
import { Input, List, Text, Dropdown } from '@wework/dieter-ui'

import React from 'react'

function LocationPicker({
  open,
  handleOpen,
  onChangeLocation,
  manager,
  currentLocationName,
  currentBuildingId,
}) {
  const [buildings, setBuildings] = useState([])
  const [searchValue, setSearchValue] = useState('')
  const [selectedBuilding, setSelectedBuilding] = useState({})
  const [currentBuilding, setCurrentBuilding] = useState('')

  useEffect(() => {
    const fetchBuildingList = async () => {
      const client = manager.getClient()

      let params = { 'filter[is_mapped]': true }

      const response = await client.get('/buildings', params)

      if (!response.meta.success) {
        // this.setState({
        //   // eslint-disable-next-line react/no-unused-state
        //   error: response.meta.message,
        // })
        return
      }
      setBuildings(_.sortBy(response.data, ['attributes.name']))
    }

    fetchBuildingList()
  }, [manager])

  useEffect(() => {
    if (currentLocationName) setCurrentBuilding(currentLocationName)
    return () => {
      setCurrentBuilding('')
    }
  }, [currentLocationName])
  const getSuggestions = inputValue => {
    const sortedSuggestion = [...buildings]

    // sort to the order I need
    sortedSuggestion.sort((a, b) => {
      const aname = a.attributes.name.toUpperCase()
      const bname = b.attributes.name.toUpperCase()
      if (aname < bname) {
        return -1
      }
      if (a > bname) {
        return 1
      }

      // name must be equal
      return 0
    })

    // return the searched results
    return sortedSuggestion.filter(suggestion => {
      const item = suggestion.attributes

      if (!inputValue) {
        return true
      }

      const foundByName = item.name
        .toLowerCase()
        .includes(inputValue.toLowerCase())
      if (foundByName) {
        return true
      }

      // check whether the user is typing for country or not
      const foundByCountry = item.country
        .toLowerCase()
        .includes(inputValue.toLowerCase())
      if (foundByCountry) {
        return true
      }

      // Check Code
      if (item.code) {
        const foundByCode = item.code
          .toLowerCase()
          .includes(inputValue.toLowerCase())
        if (foundByCode) {
          return true
        }
      }

      // check whether the user is typing for city or not
      return item.city.toLowerCase().includes(inputValue.toLowerCase())
    })
  }

  //      let name = currentLocationName || this.nextBuildingName

  //   if (open) {
  //     name = ''
  //   } else if (this.searchFieldRef && this.searchFieldRef.current) {
  //     // this.searchFieldRef.current.blur()
  //   }

  //   if (!open && !name) {
  //     const selected = buildings.find(b => {
  //       const { attributes } = b
  //       return attributes.uuid === currentBuildingId
  //     })

  //     if (selected) {
  //       const { attributes } = selected
  //       // eslint-disable-next-line prefer-destructuring
  //       name = attributes.name
  //     }
  //   }

  //   if (currentBuildingId && name) {
  //     selectedBuilding.attributes = {
  //       uuid: currentBuildingId,
  //       name,
  //     }
  //   }

  return (
    <Dropdown
      open={open}
      text={currentBuilding || 'Loading locations'}
      basic
      disabled={!currentBuilding}
      style={{ marginLeft: 4, outline: 'none' }}
      search
      scrolling
      floating
      button
      searchQuery={searchValue}
      onSearchChange={(e, data) => setSearchValue(e.currentTarget.value)}
      onClick={() => handleOpen(!open)}
    >
      <Dropdown.Menu style={{ minHeight: 320 }}>
        {getSuggestions(searchValue)?.map(building => {
          return (
            <Dropdown.Item
              onClick={() => {
                onChangeLocation(building.attributes)
                setCurrentBuilding(building.attributes.name)
                setSearchValue(building.attributes.name)

                handleOpen(false)
              }}
              value={building}
              key={building.attributes.uuid}
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 16,
              }}
            >
              <Text>{building.attributes.name}</Text>
            </Dropdown.Item>
          )
        })}
      </Dropdown.Menu>
    </Dropdown>
  )
}

// class LocationPicker extends React.PureComponent {
//   searchFieldRef = React.createRef()

//   state = {
//     buildings: [],
//   }

//   nextBuildingName = ''

//   componentDidMount() {
//     const { manager } = this.props
//     if (manager) {
//       this.fetchBuildingList()
//     }
//   }

//   async fetchBuildingList() {
//     const { manager, allowUnMappedBuilding } = this.props
//     const client = manager.getClient()

//     let params
//     if (!allowUnMappedBuilding) {
//       params = { 'filter[is_mapped]': true }
//     }

//     const response = await client.get('/buildings', params)

//     if (!response.meta.success) {
//       this.setState({
//         // eslint-disable-next-line react/no-unused-state
//         error: response.meta.message,
//       })
//       return
//     }

//     this.setState({
//       buildings: _.sortBy(response.data, ['attributes.name']),
//     })
//   }

//   render() {
//     const {
//       classes,
//       currentLocationName,
//       currentBuildingId,
//       open,
//       handleOpen,
//     } = this.props
//     const { buildings } = this.state
//     const selectedBuilding = {}

//   }
// }

// LocationPicker.propTypes = {
//   classes: T.object,
//   currentBuildingId: T.string,
//   currentLocationName: T.string,
//   onChangeLocation: T.func,
//   disabled: T.bool,
//   allowUnMappedBuilding: T.bool,
//   open: T.bool,
//   handleOpen: T.func,
//   manager: T.any,
// }

// LocationPicker.defaultProps = {
//   classes: {},
//   currentBuildingId: '',
//   currentLocationName: '',
//   onChangeLocation: () => {},
//   disabled: false,
//   allowUnMappedBuilding: false,
//   open: false,
//   handleOpen: () => {},
//   manager: null,
// }

export default compose(withManager())(LocationPicker)
